import { useTabState, Tab, TabList, TabPanel } from "@twilio-paste/reakit-library";
export { Tab as TabPrimitive, TabList as TabPrimitiveList, TabPanel as TabPrimitivePanel, useTabState as useTabPrimitiveState };